export const ROOKOO_ERROR = 'rookoo:error';
export const ROOKOO_ON_MESSAGE = 'rookoo:on-message';
export const ROOKOO_ON_START_CONVERSATION = 'rookoo:on-start-conversation';
export const ROOKOO_READY = 'rookoo:ready';
